import axios from "axios";
import { APIDomain, APIEndPOints, PostAPIEndPOints } from "./api-config";
import { AuthAPI } from "./auth-api";

export class QuoteApprovalAPI {
  static getQuoteApprovalList = async (businessCode, countryCode, quoteId = "") => {
    try {
      const _curUser = await AuthAPI.validateCurrentUser();
      const [_email, _token] = [_curUser.email, _curUser.accessToken];

      let API = APIDomain + APIEndPOints.getQuoteApprovalList;
      API = API.replace("<email>", _email);
      API = API.replace("<countryCode>", countryCode);
      API = API.replace("<businessCode>", businessCode);
      API = API.replace("<quoteId>", quoteId);
      const response = await axios.get(API, {
        headers: {
          Authorization: "Bearer " + _token,
          "x-user-agent": "Rentokil"
        },
      });

      const quoteListData =
        response.data && response.data.response && response.data.response.quoteApproval
          ? response.data.response.quoteApproval
          : [];
      return quoteListData;
    } catch (err) {
      alert(err);
    }
  };

  static fetchQuotePricingDocument = async (params) => {
    try {
      const _curUser = await AuthAPI.validateCurrentUser();
      const [_email, _token] = [_curUser.email, _curUser.accessToken];

      let API = APIDomain + APIEndPOints.fetchQuotePricingDocument;
      API = API.replace("<email>", _email);
      //API = API.replace("<email>", "sales.app1@rentokil-initial.com");
      API = API.replace("<countryCode>", params.countryCode);
      API = API.replace("<businessCode>", params.businessCode);
      API = API.replace("<quoteId>", params.quoteId);
      API = API.replace("<locale>", params.locale);
      const response = await axios.get(API, {
        headers: {
          Authorization: "Bearer " + _token,
          "x-user-agent": "Rentokil"
        }
      });

      const quotePdfData =
        response && response.data && response.data.response && response.data.response.pdf
          ? response.data.response.pdf
          : { pdf: "" };
      return quotePdfData;
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error)
        return { pdf: "", isError: true, message: err.response.data.error };
      alert(err);
    }
  };

  static updateQuoteApproval = async (postBody) => {
    try {
      const _curUser = await AuthAPI.validateCurrentUser();
      const _token = _curUser.accessToken;
      const API = APIDomain + PostAPIEndPOints.createQuoteApproval;

      const response = await axios.post(API, postBody, {
        headers: {
          Authorization: "Bearer " + _token,
          "Content-Type": "application/json",
          "x-user-agent": "Rentokil"
        },
      });

      return response;
    } catch (err) {
      alert(err);
    }
  };
}
